import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Flex,
  Button,
  HStack,
  ButtonGroup,
  Badge 
} from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import JadwalRow from "./JadwalRow";
import React, { useEffect, useState } from "react";
import ModalPengajuanJadwal from "./modalJadwal";
import scheduleService from "../../../services/report/scheduleService.js";

const perPage = 5;
const apiMapping = {
  INSPEKSI: scheduleService.getInspeksi,
  SKP: scheduleService.getSKP,
  SURVAILLANCE: scheduleService.getSurveillance
};

const PengajuanJadwalTable = () => {
  const textColor = useColorModeValue("gray.700", "white");
  const [jadwalData, setJadwalData] = useState({
    INSPEKSI: [],
    SKP: [],
    SURVAILLANCE: [],
    lainnya: []
  });

  const [pagination, setPagination] = useState({
    INSPEKSI: { page: 1, total: 0 },
    SKP: { page: 1, total: 0 },
    SURVAILLANCE: { page: 1, total: 0 },
    lainnya: { page: 1, total: 0 }
  });

  const [isOpen, setIsOpen] = useState(false);

  const captions = [
  { label: "PETUGAS", w: "150px" },
  { label: "TUJUAN UPI", w: "200px" },
  { label: "RUANG LINGKUP (Grade)", w: "180px" },
  { label: "TANGGAL", w: "150px" },
  { label: "STATUS", w: "100px" },
  { label: "", w: "30px" }
];


  // KODE BARU
const loadJadwalByJenis = async (jenis, page = 1) => {
  try {
    const apiFunc = apiMapping[jenis]; 
      const response = await apiFunc(page, perPage); 

    setJadwalData(prev => ({
      ...prev,
      [jenis]: response.data.data 
    }));

    setPagination(prev => ({
      ...prev,
      [jenis]: {
        page: page, 
        total: response.data.total 
      }
    }));
  } catch (err) {
    console.error(`Gagal load jadwal ${jenis}:`, err);
  }
};

useEffect(() => {
  ["INSPEKSI", "SKP", "SURVAILLANCE"].forEach(jenis =>
    loadJadwalByJenis(jenis, 1)
  );
}, []);


  const renderCard = (cardTitle, dataArray) => {
    const { page, total } = pagination[cardTitle];
    const totalPages = Math.ceil(total / perPage);

    return (
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} mb={4} key={cardTitle}>
        <CardHeader p="6px 0px 22px 0px">
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            {cardTitle}
          </Text>
        </CardHeader>

        <CardBody>
          <Table variant="simple" color={textColor}>
            <Thead>
                <Tr my=".8rem" pl="0px" color="gray.400">
                  {captions.map((caption, idx) => (
                    <Th
                      key={idx}
                      ps={idx === 0 ? "0px" : null}
                      w={caption.w} 
                      minW={caption.w} 
                    >
                      {caption.label}
                    </Th>
                  ))}
                </Tr>
              </Thead>

            <Tbody>
              {dataArray.map((row) => (
                <JadwalRow
                  key={row.ID}
                  nip={row.NIP}
                  tujuan={row.TUJUAN}
                  nm_upi={row.NM_UPI}
                  alamat={row.ALAMAT} 
                  kota={row.KOTA}
                  prop={row.PROP}
                  produk={row.produk}
                  grade={row.GRADE}
                  tanggal={row.TANGGAL}
                  jenis_izin={row.JENIS_IZIN}
                  kode_status={row.kode_status}
                  status={row.status}
                  personil={row.personil}
                  id={row.ID}
                  refreshData={() => loadJadwalByJenis(cardTitle, pagination[cardTitle].page)}
                />
              ))}
            </Tbody>
          </Table>
          
        </CardBody>
        <Flex justify="flex-end" mt={2} gap={2}>
            <Button
              size="sm"
              onClick={() => loadJadwalByJenis(cardTitle, page - 1)}
              disabled={page <= 1}
            >
              Prev
            </Button>
            <Text alignSelf="center" fontSize="sm">
              {page} / {totalPages}
            </Text>
            <Button
              size="sm"
              onClick={() => loadJadwalByJenis(cardTitle, page + 1)}
              disabled={page >= totalPages}
            >
              Next
            </Button>
          </Flex>
      </Card>
    );
  };

  return (
    <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
      <HStack mb={4}>
        <Button colorScheme="blue" onClick={() => setIsOpen(true)}>
          + Pengajuan Jadwal
        </Button>
        <ModalPengajuanJadwal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSuccess={() => ["INSPEKSI", "SKP", "SURVAILLANCE"].forEach(j => loadJadwalByJenis(j, 1))}
        />
      </HStack>

      {renderCard("INSPEKSI", jadwalData.INSPEKSI)}
      {renderCard("SURVAILLANCE", jadwalData.SURVAILLANCE)}
      {renderCard("SKP", jadwalData.SKP)}
      {jadwalData.lainnya.length > 0 && renderCard("LAINNYA", jadwalData.lainnya)}
    </Flex>
  );
};

export default PengajuanJadwalTable;
